import publicApiClient from './publicApi'

export type ApiKeyScope = 'read' | 'write'

export interface ApiKey {
  id: string
  name: string
  scopes: ApiKeyScope[]
  createdAt: string | null
}

export interface IssueKeyDto {
  name: string
  scopes: ApiKeyScope[]
}

export interface IssuedApiKey {
  name: string
  key: string
}

interface RawApiKey {
  uuid: string
  name: string
  scopes: ApiKeyScope[]
  created_at: string | null
}

const normalizeKey = (raw: RawApiKey): ApiKey => ({
  id: raw.uuid,
  name: raw.name,
  scopes: raw.scopes,
  createdAt: raw.created_at,
})

export const ApiKeysService = {
  list: async (): Promise<ApiKey[]> => {
    const { data } = await publicApiClient.get<RawApiKey[]>('/v1/api-keys')

    return data.map(normalizeKey)
  },

  create: async (dto: IssueKeyDto): Promise<IssuedApiKey> => {
    const { data } = await publicApiClient.post<IssuedApiKey>(
      '/v1/api-keys',
      dto
    )

    return data
  },

  revoke: async (id: string): Promise<void> => {
    await publicApiClient.delete(`/v1/api-keys/${id}`)
  },
}
